import React from 'react';
import styles from './RevenueTooltip.module.css';

interface RevenueTooltipProps {
	active?: boolean;
	payload?: any[];
}

export const RevenueTooltip: React.FC<RevenueTooltipProps> = ({ active, payload }) => {
	if (!active || !payload || payload.length === 0) {
		return null;
	}

	const data = payload[0];
	const formattedValue = `R$ ${data.value.toLocaleString('pt-BR')}`;
	const color = data.stroke || data.color || '#689ee6';

	return (
		<div className={styles.tooltip}>
			<div className={styles.item}>
				<div className={styles.labelWrapper}>
					<div className={styles.dot} style={{ backgroundColor: color }} />
					<span className={styles.label}>Faturamento</span>
				</div>
				<span className={styles.value}>{formattedValue}</span>
			</div>
		</div>
	);
};
